import { render } from "./Workshop.vue?vue&type=template&id=239f8969"
import script from "./Workshop.vue?vue&type=script&lang=js"
export * from "./Workshop.vue?vue&type=script&lang=js"
script.render = render

export default script